export default function (form, component, keditor) {
  const timeDelayArr = keditor.options.contentScripts.footer_system.content.timeDelayArr[component.attr('id')]
  form.find('#form-time-delay').val(timeDelayArr ? timeDelayArr : 0)
}
